import csuBanner from '../assets/het-geluid-2023-nl/csu_banner.gif'
import headerImage2023NL from '../assets/het-geluid-2023-nl/header_image.jpg'
import headerImage2023BE from '../assets/het-geluid-2023-be/header_image.jpg'

/*
    type: welk type aanmeldmoment is het? sockets / api
    theme: welk merk is het aanmeldmoment voor? qmusic / joe 
    copy: {
        title: titel van het aanmeldmoment
        description: beschrijving van het aanmeldmoment
        button: tekst op de aanmeldknop
        success: {
            title: titel van de succesmelding
            description: beschrijving van de succesmelding
            button: tekst op de succesknop
        }
    }
*/

const campaign = new URLSearchParams(window.location.search).get('campaign') || 'het_geluid_nl'

const configs = {
  het_geluid_nl: {
    stationId: 'qmusic_nl',
    theme: 'qmusic',
    type: 'api',
    title: 'Het Geluid NL',
    headerImage: headerImage2023NL,
    mixpanelId: '594a9082a210d6c538a93a2acdc8411a',
    campaignPageLink: 'https://qmusic.nl/embed/het-geluid-2023',
    sponsorImage: csuBanner,
    sponsorLink: 'https://qrad.io/3DbI26J',
    translation: {
      campaign: {
        name: 'het geluid',
        description: `Speel mee met het spannendste spel van de Nederlandse radio: Het Geluid!
            Denk jij te weten wat Het Geluid is? Dan ben jij klaar om mee te spelen!
            Meld je hieronder elke dag aan dan maak jij kans om Het Geluid te raden.`,
        extraInfo: '',
      },
      campaignPage: {
        linkCopy: 'Lees meer over het geluid',
      },
      wrongAnswers: {
        title: 'Foute antwoorden',
        description: 'Dit zijn de foute antwoorden die al gegeven zijn op de radio.',
      },
      signupMoment: {
        title: 'Meld je aan voor het geluid',
        preview: {
          title: 'Elke weekdag',
          description: `Meespelen met het geluid kan enkel van maandag tot en met vrijdag, 7 tot
                19u. Laat je brein dus gerust nog even rusten om binnenkort terug
            keihard mee te zoeken!`,
        },
        running: {
          btn: 'Meld mij aan',
        },
        success: {
          title: 'Je bent aangemeld voor {{moment}}!',
          description: `<strong>Houd je telefoon in de gaten</strong>, wie weet pikt onze computer jou er uit om mee te spelen.`,
          warning: `<strong>Let op:</strong> morgen moet je je opnieuw aanmelden.`,
        },
      },
    },
  },
  het_geluid_be: {
    stationId: 'qmusic_be',
    theme: 'qmusic',
    type: 'sockets',
    title: 'Het Geluid BE',
    headerImage: headerImage2023BE,
    campaignPageLink: 'https://qmusic.be/embed/het-geluid-komt-terug-1',
    mixpanelId: '5796350b8d04ac9c3ab5759b4a62f743',
    sound: {
      url: 'https://cdn-radio.dpgmedia.net/store/media/het-geluid-2023-2.mp3',
      code: 'het-geluid-2023-2',
    },
    campaignActive: 6 < new Date().getHours() && new Date().getHours() < 19 && new Date().getDay() < 6,
    campaignEnded: true,
    translation: {
      campaign: {
        name: 'het geluid',
        description: `Het Geluid is geraden 

        Ellen uit Genk wint 16.800 euro met Het Geluid: 'een opzetstukje op een elektrische tandenborstel klikken'. 
        Bedankt om mee te zoeken! `,
      },
      campaignPage: {
        linkCopy: '',
      },
      wrongAnswers: {
        title: 'Foute antwoorden',
        description: 'Hieronder vind je alle antwoorden die al gegeven zijn op de radio en fout waren.',
      },
      signupMoment: {
        title: 'Meld je aan voor het geluid',
        preview: {
          title: 'Nog even geduld',
          description: `Luister naar Qmusic en kom te weten wanneer je kan aanmelden voor het volgende spelmoment van Het Geluid!`,
        },
        notRunning: {
          title: 'Nog even geduld',
          description: `Meespelen met Het Geluid kan enkel van maandag tot en met vrijdag van 6u tot 19u. Laat je brein dus nog even rusten en herbeluister hier in de app nog een paar keer Het Geluid om zeker te zijn van je stuk.`,
        },
        running: {
          btn: 'Meld mij aan',
        },
        success: {
          title: 'Je bent aangemeld voor {{moment}}!',
          description:
            '<strong>Houd je telefoon in de gaten</strong>, wie weet pikt onze computer jou er uit om mee te spelen.',
          warning: '',
        },
      },
      soundListener: {
        title: 'Luister naar het geluid',
        description: '',
      },
    },
  },
  het_geluid_test: {
    stationId: 'test_station',
    theme: 'qmusic',
    type: 'sockets',
    title: 'Het Geluid BE',
    headerImage: headerImage2023BE,
    campaignPageLink: 'https://qmusic.be/het-geluid',
    sound: {
      url: 'https://samplelib.com/lib/preview/mp3/sample-6s.mp3',
      code: 'het-geluid-2023-1',
    },
    translation: {
      campaign: {
        name: 'het geluid',
        description:
          'Weet jij wat Het Geluid is? Speel hier mee! Meld je hieronder elk uur aan en maak kans om mee te raden.',
        extraInfo: `Elk uur kan je je aanmelden om mee te spelen met het volgende spelmoment van Het Geluid. 
        Tijdens de Superronde om 9u30 mag je 2 x raden, dubbel zoveel kans om het juiste antwoord te geven! `,
      },
      campaignPage: {
        linkCopy: 'Lees meer over Het Geluid.',
      },
      wrongAnswers: {
        title: 'Foute antwoorden',
        description: 'Hieronder vind je alle antwoorden die al gegeven zijn op de radio en fout waren.',
      },
      signupMoment: {
        title: 'Meld je aan voor het geluid',
        preview: {
          title: 'Elke weekdag',
          description:
            'Meespelen met Het Geluid kan enkel van maandag tot en met vrijdag van 7u tot 19u. Laat je brein dus nog even rusten en herbeluister hier in de app nog een paar keer Het Geluid om zeker te zijn van je stuk.',
        },
        running: {
          btn: 'Meld mij aan',
        },
        success: {
          title: 'Je bent aangemeld voor {{moment}}!',
          description:
            '<strong>Houd je telefoon in de gaten</strong>, wie weet pikt onze computer jou er uit om mee te spelen.',
          warning: '',
        },
      },
      soundListener: {
        title: 'Luister naar het geluid',
        description: 'Spits je oren en raad wat het is.',
      },
    },
  },
}

export default configs
export const CAMPAIGN_NAME = campaign
export const CAMPAIGN_CONFIG = configs[campaign]
